function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import * as React from "react";

function SvgIconPocMuseumFilled(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 32,
    height: 32,
    viewBox: "0 0 32 32",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), /*#__PURE__*/React.createElement("path", {
    d: "M16 4.061L24.226 7h5.944L16 1.94 1.827 6.998h5.944L16 4.061zM2 11h28V9H2v2zM8 22H6v-9h2v9zM14 22h-2v-9h2v9zM18 22h2v-9h-2v9zM26 22h-2v-9h2v9zM30 30H2v-2h28v2zM28 26H4v-2h24v2z",
    fill: props.color
  }));
}

export default SvgIconPocMuseumFilled;